import SetupModulePage from './SetupModulePage';
import SetupModulePageDescription from './SetupModulePageDescription';

export default SetupModulePage;
export { SetupModulePageDescription };
